import { hamburgerButton } from './lib/elements.js'
import { toggleMenu } from './lib/handlers.js'
import { handleFirstTab, disableAnimationOnResize } from './lib/lib.js'

// Hamburger toggle
hamburgerButton.addEventListener('click', toggleMenu)
document.addEventListener('keyup', toggleMenu)

// Remove :focus outline unless user is using the keyboard to navigate
window.addEventListener('keydown', handleFirstTab)

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize)
